module.exports = __webpack_public_path__ + "static/media/GRASIM_F1.7e2e5b91.txt";